export const STYLES = [
  // Background-replace styles first: people stay exactly as photographed,
  // only the environment behind them is swapped.
  {
    id: "bg_casino",
    title: "Casino Monte Carlo",
    subtitle: "Samo zamenjava ozadja",
    image: "/styles/bg_casino.png",
  },
  {
    id: "bg_aston",
    title: "Nočni London",
    subtitle: "Aston Martin · samo ozadje",
    image: "/styles/bg_aston.png",
  },
  {
    id: "bg_rooftop",
    title: "Strešna terasa",
    subtitle: "Samo zamenjava ozadja",
    image: "/styles/bg_rooftop.png",
  },
  {
    id: "bg_yacht",
    title: "Jahta na Rivieri",
    subtitle: "Samo zamenjava ozadja",
    image: "/styles/bg_yacht.png",
  },
  // Full-restyle looks
  {
    id: "casino_royale",
    title: "Klasični smoking",
    subtitle: "Casino Royale",
    image:
      "https://static.prod-images.emergentagent.com/jobs/df773180-95d6-48d0-a64d-778fe5a27d25/images/01cfbae6b4164d5142b21b7f54c20f9fccacbe235bebd80c234816762cc56216.png",
  },
  {
    id: "action_scene",
    title: "Akcijska scena",
    subtitle: "Aston Martin · London",
    image:
      "https://static.prod-images.emergentagent.com/jobs/df773180-95d6-48d0-a64d-778fe5a27d25/images/fd2b7f7be1da96cf1829d2f7a1f52d3e0ae46e190d046d5ccc17c7dd103b8e41.png",
  },
  {
    id: "gala_dinner",
    title: "Gala večerja",
    subtitle: "Blišč in eleganca",
    image:
      "https://static.prod-images.emergentagent.com/jobs/df773180-95d6-48d0-a64d-778fe5a27d25/images/43d766e3bde1cac0c85fbe3b2bda4608c0eea073450a84bdd830ca25d00e1018.png",
  },
  {
    id: "female_agent",
    title: "Skrivnostna agentka",
    subtitle: "Večerna obleka",
    image:
      "https://static.prod-images.emergentagent.com/jobs/df773180-95d6-48d0-a64d-778fe5a27d25/images/bfa96c42f4cfb0a2f9225e6c06030c0a92a29dabfb7c23d062bd330aaf58b239.png",
  },
];

export const LOGO_URL = "/logo.png";

export const GUN_BARREL_BG =
  "https://static.prod-images.emergentagent.com/jobs/df773180-95d6-48d0-a64d-778fe5a27d25/images/8a1606b62b8fa183d24aa2eac395f1be3c79ae22b244dd5764a20f410acbec19.png";
